module.exports = __webpack_public_path__ + "img/hospital.f76e8408.svg";